module.exports = __webpack_public_path__ + "assets/img/1-3.9e9e514d.jpg";